<div fxLayout="row wrap" fxLayoutAlign="space-between start">
    <h2 class="dialog-title" mat-dialog-title>{{"Choisir Utilisateur" | translate}}</h2>
    <button class="dialog-close-btn" mat-dialog-close mat-icon-button>
        <mat-icon>close</mat-icon>
    </button>
</div>
<div *ngIf="certificates!=undefined && certificates!=null" mat-dialog-content>

    <!--    <div fxFlex="100" fxFlex.lt-md="100">-->
    <mat-card appCard class="table-card">
        <mat-card-content>
            <ng-container>
                <table [dataSource]="dataSource" mat-table style="width: 100%"
                >
                    <ng-container *ngFor="let column of readColumns" [matColumnDef]="column">
                        <th *matHeaderCellDef mat-header-cell translate>
                            <span>{{ labels[column] }}</span>
                        </th>
                        <td *matCellDef="let type" mat-cell translate>
                            <span> {{ type[column]  }}</span>
                        </td>
                    </ng-container>

                    <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
                    <tr (click)="selection.toggle(row)" (click)="toggle()" (mouseout)="row.hovered = false"
                        (mouseover)="row.hovered = true"

                        *matRowDef="let row; columns: displayedColumns"
                        [ngClass]="{hovered: row.hovered, highlighted: selection.isSelected(row)}" mat-row></tr>
                </table>
                <app-empty-list-container
                        [list]="dataSource.data"
                        [withoutBorder]="true"
                ></app-empty-list-container>
                <app-paginator
                        (paginate)="onPaginate($event)"
                        [pageSize]="paginationObject.limit"
                        [total]="certificates.length"
                ></app-paginator>
            </ng-container>
            <app-spinner-container [isLoading]="certificates == null || certificates == undefined">
            </app-spinner-container>
        </mat-card-content>
    </mat-card>
    <!--    </div>-->
    <div class="mt-3" fxLayout="row" fxLayoutAlign="end center">
        <button (click)="onSuccess()" [disabled]="disabled_conn" color="primary" mat-raised-button>
            <span translate>Se Connecter</span>
        </button>
    </div>


    <!-- <div [disabled]="disabled_conn" mat-dialog-actions fxLayoutAlign="end end">
      <app-spinner-container>
        <button  color="primary" mat-raised-button>
          <span translate>submit</span>
        </button>
      </app-spinner-container>
    </div> -->
</div>
<!--<div mat-dialog-actions fxLayoutAlign="end end">-->
<!--    <app-spinner-container>-->
<!--        <button (click)="onSuccess()" color="primary" [disabled]="disabled_conn" mat-raised-button tu>-->
<!--            <span translate>Se Connecter</span>-->
<!--        </button>-->
<!--    </app-spinner-container>-->
<!--</div>-->


